export default function WhatIsSection() {
  return (
    <section id="czym-jest" className="py-16 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 lg:px-8 max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">
            Czym jest Kakobuy Spreadsheet?
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-2xl mx-auto">
            Kakobuy Spreadsheet to uporządkowana baza produktów, linków oraz rekomendacji, która pomaga użytkownikom szybciej znaleźć interesujące produkty.
          </p>
        </div>

        <div className="max-w-4xl mx-auto overflow-x-auto">
          <table className="w-full text-sm border-collapse">
            <thead>
              <tr className="border-b-2 border-background-300/60">
                <th className="text-left py-4 px-6 font-semibold text-foreground-900">Tradycyjne wyszukiwanie</th>
                <th className="text-left py-4 px-6 font-semibold text-accent-600">Kakobuy Spreadsheet</th>
              </tr>
            </thead>
            <tbody>
              <tr className="border-b border-background-200/70">
                <td className="py-4 px-6 text-foreground-600"><strong className="font-medium text-foreground-800">Czas:</strong> Długi</td>
                <td className="py-4 px-6 text-foreground-600"><strong className="font-medium text-foreground-800">Czas:</strong> Krótki</td>
              </tr>
              <tr className="border-b border-background-200/70">
                <td className="py-4 px-6 text-foreground-600"><strong className="font-medium text-foreground-800">Organizacja:</strong> Brak</td>
                <td className="py-4 px-6 text-foreground-600"><strong className="font-medium text-foreground-800">Organizacja:</strong> Gotowe listy</td>
              </tr>
              <tr className="border-b border-background-200/70">
                <td className="py-4 px-6 text-foreground-600"><strong className="font-medium text-foreground-800">Porównanie:</strong> Trudne</td>
                <td className="py-4 px-6 text-foreground-600"><strong className="font-medium text-foreground-800">Porównanie:</strong> Łatwe</td>
              </tr>
              <tr className="border-b border-background-200/70">
                <td className="py-4 px-6 text-foreground-600"><strong className="font-medium text-foreground-800">Dla początkujących:</strong> Nie</td>
                <td className="py-4 px-6 text-foreground-600"><strong className="font-medium text-foreground-800">Dla początkujących:</strong> Tak</td>
              </tr>
              <tr>
                <td className="py-4 px-6 text-foreground-600"><strong className="font-medium text-foreground-800">Bezpieczeństwo:</strong> Niskie</td>
                <td className="py-4 px-6 text-foreground-600"><strong className="font-medium text-foreground-800">Bezpieczeństwo:</strong> Wysokie</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </section>
  );
}